import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getOrdersList } from "../../../api/order";

export const fetchOrdersList = createAsyncThunk(
  "fetchOrdersList",
  async (payload) => {
    const response = await getOrdersList(payload);
    return response;
  }
);
const orderSlice = createSlice({
  name: "order",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrdersList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchOrdersList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
      })
      .addCase(fetchOrdersList.rejected, (state, action) => {
        state.status = "failed";
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});
export { orderSlice };
